import { useCallback } from "react";
import { Link } from "react-router";
import { formatShopPrice } from "@shared/shop/price";
import { routes } from "../../app/routes";
import { useResource } from "../../platform/async/useResource";
import { StateMessage } from "../../platform/ui/StateMessage";
import { fetchListing } from "../shop";
import { ContactForm } from "./ContactForm";

export function EnquiryForm({
  slug,
  turnstileSiteKey,
}: {
  slug: string;
  turnstileSiteKey: string;
}) {
  const listing = useResource(useCallback((signal) => fetchListing(slug, signal), [slug]));
  if (listing.status === "loading")
    return <StateMessage tone="loading" title="Fetching the listing" />;
  if (listing.status === "failed")
    return (
      <div data-slot="stage">
        <StateMessage
          tone="error"
          title="This enquiry could not be prepared"
          {...(listing.error.failure === "not_found"
            ? {}
            : { action: { label: "Try again", onSelect: listing.retry } })}
        >
          The listing may be unavailable. <Link to={routes.shop()}>Return to the shop</Link> or{" "}
          <Link to={routes.contact()}>send a general message</Link>.
        </StateMessage>
      </div>
    );
  return (
    <ContactForm
      turnstileSiteKey={turnstileSiteKey}
      listingSlug={listing.data.slug}
      initialMessage={`Hello Orla, I am interested in ${listing.data.title} (${formatShopPrice(listing.data)}).\n\nHere is what I need: `}
    />
  );
}
